import React, { useEffect, useState } from 'react';
//import './assets/css/body.css'; // Import CSS from the theme
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import PrimarySearchBox from './PrimarySearchBox';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import {Helmet} from "react-helmet";

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { SubscribeRibbon } from './SubscribeRibbon';

function Home() {

  const [widgetData, setWidgetData] = useState([]);

  useEffect(() => {
    const setCustomAttributes = () => {
      const sectionSliders = document.querySelectorAll('.js-section-slider');
      sectionSliders.forEach((slider) => {
        if (!slider.getAttribute('data-gap')) {
          slider.setAttribute('data-gap', '30');
        }
        if (!slider.getAttribute('data-scrollbar')) {
          slider.setAttribute('data-scrollbar', '');
        }
        if (!slider.getAttribute('data-slider-cols')) {
          slider.setAttribute('data-slider-cols', 'base-2 xl-4 lg-3 md-2 sm-2 base-1');
        }
        if (!slider.getAttribute('data-anim')) {
          slider.setAttribute('data-anim', 'slide-up');
        }
      });
    };
  
    setCustomAttributes();
  
    /*
    const initializeSwiper = () => {
      new Swiper('.js-section-slider', {
        // Swiper configuration options
        loop: true,
        slidesPerView:4,
        spaceBetween:30
      });
    };
  
    // Wait for the DOM elements to render before initializing Swiper
    setTimeout(initializeSwiper, 50);
    */
  }, [widgetData]);

  useEffect(() => {
    const fetchWidgetData = async () => {
      try {
        const apiUrl = `${process.env.REACT_APP_API_ENDPOINT}admin_homepage_widgets`;
        const response = await fetch(apiUrl);
        const data = await response.json();
        setWidgetData(data);
      } catch (error) {
        console.error('Error fetching widget data:', error);
      }
    };
  
    fetchWidgetData();
  }, []);
  
  const fetchHotelData = async (ids, widgetId) => {
    try {
      const apiUrl = `${process.env.REACT_APP_API_ENDPOINT}hotel_listings?id=${ids}`;
      console.log("apiUrl:", apiUrl);
      const response = await fetch(apiUrl);
      const data = await response.json();
      setWidgetData((prevData) =>
        prevData.map((widget) =>
          widget.id === widgetId ? { ...widget, hotelData: data } : widget
        )
      );
    } catch (error) {
      console.error('Error fetching hotel data:', error);
    }
  };
  
  const fetchTourData = async (ids, widgetId) => {
    try {
      const apiUrl = `${process.env.REACT_APP_API_ENDPOINT}tour_listings?id=${ids}`;
      console.log("Tour API: ", apiUrl);
      const response = await fetch(apiUrl);
      const data = await response.json();
      setWidgetData((prevData) =>
        prevData.map((widget) =>
          widget.id === widgetId ? { ...widget, packageData: data } : widget
        )
      );
    } catch (error) {
      console.error('Error fetching tour data:', error);
    }
  };

  const fetchProductData = async (ids, widgetId) => {
    try {
      if(ids){
        const apiUrl = `${process.env.REACT_APP_API_ENDPOINT}product_listings?id=${ids}`;
        console.log("product API: ", apiUrl);
        const response = await fetch(apiUrl);
        const data = await response.json();
        setWidgetData((prevData) =>
          prevData.map((widget) =>
            widget.id === widgetId ? { ...widget, productData: data } : widget
          )
        );
      }
    } catch (error) {
      console.error('Error fetching tour data:', error);
    }
  };

  const fetchHomamData = async (ids, widgetId) => {
    try {
      if(ids){
        const apiUrl = `${process.env.REACT_APP_API_ENDPOINT}homam_listings?id=${ids}`;
        console.log("Homam API", apiUrl);
        const response = await fetch(apiUrl);
        const data = await response.json();
        setWidgetData((prevData) =>
          prevData.map((widget) =>
            widget.id === widgetId ? { ...widget, homamData: data } : widget
          )
        );
      }
    } catch (error) {
      console.error('Error fetching tour data:', error);
    }
  };
  
  useEffect(() => {
    const fetchDataForWidgets = async () => {
      for (const widget of widgetData) {
        if (widget.widget_category === 'hotels' && !widget.hotelData) {
          await fetchHotelData(widget.widget_ids, widget.id);
        } else if (widget.widget_category === 'packages' && !widget.packageData) {
          await fetchTourData(widget.widget_ids, widget.id);
        } else if (widget.widget_category === 'homam' && !widget.homamData) {
          await fetchHomamData(widget.widget_ids, widget.id);
        } else if (widget.widget_category === 'astrology' && !widget.homamData) {
          await fetchHomamData(widget.widget_ids, widget.id);
        } else if (widget.widget_category === 'products' && !widget.productData) {
          await fetchProductData(widget.widget_ids, widget.id);
        } 
      }
    };
  
    fetchDataForWidgets();
  }, [widgetData]);

  const renderWidgetSections = () => {
    return widgetData.map((widget) => {
      if (widget.widget_category === 'packages' && widget.packageData) {
        return (
          <section key={widget.id} className="layout-pt-lg layout-pb-md">
            <div className="container">
              <div data-anim="slide-up delay-1" className="row y-gap-20 justify-between items-end is-in-view">
                <div className="col-auto">
                  <div className="sectionTitle -md">
                    <h2 className="sectionTitle__title">{widget.widget_name}</h2>
                  </div>
                </div>

                <div className="col-auto md:d-none">

                  <a href="/travels/travel/page/1" className="button -md -blue-1 bg-blue-1-05 text-blue-1">
                    View All Holidays <div className="icon-arrow-top-right ml-15"></div>
                  </a>

                </div>
              </div>

              <div className="relative pt-40 sm:pt-20 js-section-slider swiper-initialized swiper-horizontal swiper-pointer-events swiper-autoheight swiper-watch-progress swiper-backface-hidden is-in-view">
                <div className="swiper-wrapper">
                  <Swiper
                    spaceBetween={30}
                    autoplay={{
                      delay: 2500,
                      disableOnInteraction: false,
                    }}
                    loop={true}
                    navigation={true}
                    modules={[Autoplay, Navigation]}
                    className="mySwiper"
                    breakpoints={{
                      // When window width is <= 767px (typically mobile phones), show 2 slides
                      767: {
                        slidesPerView: 2,
                      },
                      // Default: When window width is > 767px, show 4 slides
                      // You can adjust this breakpoint based on your design requirements
                      768: {
                        slidesPerView: 4,
                      },
                    }}
                  >
                  {widget.packageData.map((hpackage) => (
                    <SwiperSlide>
                      <div className="swiper-slide swiper-slide-visible swiper-slide-active" key={hpackage.id} 
                      style={{marginRight: '30px'}}>

                        <a href={`/travel-india/tour-package/id/${hpackage.id}/${hpackage.name.replace(/\s+/g, '-')}`} className="citiesCard -type-1 d-block rounded-4 ">
                          <div className="citiesCard__image ratio ratio-1:1">
                            <img
                              src={hpackage.thumb_new ? `${process.env.REACT_APP_API_ENDPOINT}uploads/${hpackage.thumb_new.replace(/ /g, '%20')}` : `/img/uploads/tour/thumbs/${hpackage.thumb}`}
                              data-src={hpackage.thumb_new ? `${process.env.REACT_APP_API_ENDPOINT}uploads/${hpackage.thumb_new.replace(/ /g, '%20')}` : `/img/uploads/tour/thumbs/${hpackage.thumb}`}
                              alt="image"
                            />
                          </div>

                          <div className="citiesCard__content d-flex flex-column justify-between text-center pt-30 pb-20 px-20">
                            <div className="citiesCard__bg"></div>

                            <div className="citiesCard__top">
                              <div className="text-14 text-white">{hpackage.nights} Night {hpackage.days} Days</div>
                            </div>

                            <div className="citiesCard__bottom">
                              <h4 className="text-20 md:text-20 lh-13 text-white mb-20">{hpackage.name}</h4>
                              {hpackage.price !== '' && hpackage.price !== 0 ? (
                                <>
                                  <p className="starts_from">Starts from ₹{hpackage.price}/-</p>
                                </>
                              ) : (
                                <>
                                  <p className="starts_from">Contact Us for Pricing</p>
                                </>
                              )}
                              <button className="button col-12 h-60 -blue-1 bg-white text-dark-1">View Details</button>
                            </div>
                          </div>
                        </a>

                      </div>
                    </SwiperSlide>
                  ))}
                  </Swiper>
                </div>
                

                {/*
                <button className="section-slider-nav -prev flex-center button -blue-1 bg-white shadow-1 size-40 rounded-full sm:d-none js-prev">
                  <i className="icon icon-chevron-left text-12"></i>
                </button>

                <button className="section-slider-nav -next flex-center button -blue-1 bg-white shadow-1 size-40 rounded-full sm:d-none js-next">
                  <i className="icon icon-chevron-right text-12"></i>
                </button>


                <div className="slider-scrollbar bg-light-2 mt-40 sm:d-none js-scrollbar"></div>
                */}

                <div className="row pt-20 d-none md:d-block">
                  <div className="col-auto">
                    <div className="d-inline-block">

                      <a href="#" className="button -md -blue-1 bg-blue-1-05 text-blue-1">
                        View All Destinations <div className="icon-arrow-top-right ml-15"></div>
                      </a>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        );
      } else if (widget.widget_category === 'hotels' && widget.hotelData) {
        return (
          <section key={widget.id} className="layout-pt-md layout-pb-md">
            <div data-anim="slide-up delay-1" className="container is-in-view">
              <div className="row y-gap-10 justify-between items-end">
                <div className="col-auto">
                  <div className="sectionTitle -md">
                    <h2 className="sectionTitle__title">{widget.widget_name}</h2>
                  </div>
                </div>
      
                <div className="col-auto md:d-none">
      
                  <a href="/hotels/page/1" className="button -md -blue-1 bg-blue-1-05 text-blue-1">
                    View All Hotels <div className="icon-arrow-top-right ml-15"></div>
                  </a>
      
                </div>
              </div>
      
              <div className="relative overflow-hidden pt-40 sm:pt-20 js-section-slider swiper-initialized swiper-horizontal swiper-backface-hidden swiper-pointer-events swiper-autoheight swiper-watch-progress is-in-view" data-gap="30" data-scrollbar data-slider-cols="xl-4 lg-3 md-2 sm-2 base-1" data-nav-prev="js-hotels-prev" data-pagination="js-hotels-pag" data-nav-next="js-hotels-next">
                <div className="swiper-wrapper">
                  <Swiper
                    spaceBetween={30}
                    autoplay={{
                      delay: 2500,
                      disableOnInteraction: false,
                    }}
                    loop={true}
                    navigation={true}
                    modules={[Autoplay, Navigation]}
                    className="mySwiper"
                    breakpoints={{
                      // When window width is <= 767px (typically mobile phones), show 2 slides
                      767: {
                        slidesPerView: 2,
                      },
                      // Default: When window width is > 767px, show 4 slides
                      // You can adjust this breakpoint based on your design requirements
                      768: {
                        slidesPerView: 4,
                      },
                    }}
                  >
                  {widget.hotelData.map((hotel) => (
                    <SwiperSlide>
                      <div className="swiper-slide swiper-slide-visible swiper-slide-active" style={{marginRight:"30px"}} key={hotel.id}>
          
                        <a href={`/hotel/${hotel.name.toLowerCase().replace(/\s+/g, '-')}/${hotel.id}`} className="hotelsCard -type-1 ">
                          <div className="hotelsCard__image">
          
                            <div className="cardImage ratio ratio-1:1">
                              <div className="cardImage__content">
                                <img
                                src={
                                  hotel.hotel_image_new.includes('aim_')
                                    ? `/img/uploads/hotels/roomgallery/${hotel.hotel_image_new.replace(/ /g, '%20')}`
                                    : `${process.env.REACT_APP_API_ENDPOINT}uploads/hotels/${hotel.hotel_image_new.replace(/ /g, '%20')}`
                                }
                                alt="image"
                                />
          
                              </div>
          
                            </div>
          
                          </div>
          
                          <div className="hotelsCard__content mt-10">
                            <h4 className="hotelsCard__title text-dark-1 text-18 lh-16 fw-500">
                              <span>{hotel.name}</span>
                            </h4>
          
                            <p className="text-light-1 lh-14 text-14 mt-5">{hotel.city ? hotel.city : ''}{hotel.state ? ', '+hotel.state : ''}</p>
          
                            <div className="mt-5">
                              <div className="fw-500">
                                {!hotel.price || hotel.price === 0
                                  ? ""
                                  : 'Starting from '}
                                <span className="text-blue-1">
                                {!hotel.price || hotel.price === 0
                                  ? "Contact us for Price"
                                  : `₹${hotel.price}/-`}
                                </span>
                              </div>
                            </div>
                          </div>
                        </a>
          
                      </div>
                    </SwiperSlide>
                  ))}
                  </Swiper>
                </div>
      
              </div>
            </div>
          </section>
        );
      } else if (widget.widget_category === 'products' && widget.productData) {
        return (
          <section key={widget.id} className="layout-pt-md layout-pb-md">
            <div data-anim="slide-up delay-1" className="container is-in-view">
              <div className="row y-gap-10 justify-between items-end">
                <div className="col-auto">
                  <div className="sectionTitle -md">
                    <h2 className="sectionTitle__title">{widget.widget_name}</h2>
                  </div>
                </div>
      
                <div className="col-auto md:d-none">
      
                  <a href="/products/page/1" className="button -md -blue-1 bg-blue-1-05 text-blue-1">
                    View All Products <div className="icon-arrow-top-right ml-15"></div>
                  </a>
      
                </div>
              </div>
      
              <div className="relative overflow-hidden pt-40 sm:pt-20 js-section-slider swiper-initialized swiper-horizontal swiper-backface-hidden swiper-pointer-events swiper-autoheight swiper-watch-progress is-in-view" data-gap="30" data-scrollbar data-slider-cols="xl-4 lg-3 md-2 sm-2 base-1" data-nav-prev="js-hotels-prev" data-pagination="js-hotels-pag" data-nav-next="js-hotels-next">
                <div className="swiper-wrapper">
                  <Swiper
                    spaceBetween={30}
                    autoplay={{
                      delay: 2500,
                      disableOnInteraction: false,
                    }}
                    loop={true}
                    navigation={true}
                    modules={[Autoplay, Navigation]}
                    className="mySwiper"
                    breakpoints={{
                      // When window width is <= 767px (typically mobile phones), show 2 slides
                      767: {
                        slidesPerView: 2,
                      },
                      // Default: When window width is > 767px, show 4 slides
                      // You can adjust this breakpoint based on your design requirements
                      768: {
                        slidesPerView: 4,
                      },
                    }}
                  >
                    {widget.productData.map((hotel) => (
                      <SwiperSlide>
                        <div className="swiper-slide swiper-slide-visible swiper-slide-active" style={{marginRight:"30px"}} key={hotel.id}>
            
                          <a href={`/product/${hotel.product_name.toLowerCase().replace(/\s+/g, '-')}/${hotel.id}`} className="hotelsCard -type-1 ">
                            <div className="hotelsCard__image">
            
                              <div className="cardImage ratio ratio-1:1">
                                <div className="cardImage__content">
                                  <img
                                  src={`${process.env.REACT_APP_API_ENDPOINT}uploads/shopping/${hotel.image_src !== null ? hotel.image_src.replace(/ /g, '%20') : ''}`}
                                  alt="image"
                                  />
            
                                </div>
            
                              </div>
            
                            </div>
            
                            <div className="hotelsCard__content mt-10 text-center">
                              <h4 className="hotelsCard__title text-dark-1 text-18 lh-16 fw-500">
                                <span>{hotel.product_name}</span>
                              </h4>
            
                              <div className="mt-5">
                                <div className="fw-500">
                                  {!hotel.price || hotel.price === 0
                                    ? ""
                                    : ''}
                                  <span className="text-blue-1">
                                  {!hotel.price || hotel.price === 0
                                    ? "Contact us for Price"
                                    : `₹${hotel.price}/-`}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </a>
            
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
      
              </div>
            </div>
          </section>
        );
      } else if (widget.widget_category === 'homam' && widget.homamData) {
        return (
          <section key={widget.id} className="layout-pt-md layout-pb-md">
            <div data-anim="slide-up delay-1" className="container is-in-view">
              <div className="row y-gap-10 justify-between items-end">
                <div className="col-auto">
                  <div className="sectionTitle -md">
                    <h2 className="sectionTitle__title">{widget.widget_name}</h2>
                  </div>
                </div>
      
                <div className="col-auto md:d-none">
      
                  <a href="/homam-astrology/page/1" className="button -md -blue-1 bg-blue-1-05 text-blue-1">
                    View All Homam <div className="icon-arrow-top-right ml-15"></div>
                  </a>
      
                </div>
              </div>
      
              <div className="relative overflow-hidden pt-40 sm:pt-20 js-section-slider swiper-initialized swiper-horizontal swiper-backface-hidden swiper-pointer-events swiper-autoheight swiper-watch-progress is-in-view" data-gap="30" data-scrollbar data-slider-cols="xl-4 lg-3 md-2 sm-2 base-1" data-nav-prev="js-hotels-prev" data-pagination="js-hotels-pag" data-nav-next="js-hotels-next">
                <div className="swiper-wrapper">
                  <Swiper
                    spaceBetween={30}
                    autoplay={{
                      delay: 2500,
                      disableOnInteraction: false,
                    }}
                    loop={true}
                    navigation={true}
                    modules={[Autoplay, Navigation]}
                    className="mySwiper"
                    breakpoints={{
                      // When window width is <= 767px (typically mobile phones), show 2 slides
                      767: {
                        slidesPerView: 2,
                      },
                      // Default: When window width is > 767px, show 4 slides
                      // You can adjust this breakpoint based on your design requirements
                      768: {
                        slidesPerView: 4,
                      },
                    }}
                  >
                    {widget.homamData.map((hotel) => (
                      <SwiperSlide>
                        <div className="swiper-slide swiper-slide-visible swiper-slide-active" style={{marginRight:"30px"}} key={hotel.id}>
            
                          <a href={`/homam-astrology/${hotel.id}/${hotel.name.toLowerCase().replace(/\s+/g, '-')}`} className="hotelsCard -type-1 ">
                            <div className="hotelsCard__image">
            
                              <div className="cardImage ratio ratio-1:1">
                                <div className="cardImage__content">
                                  <img
                                  src={`${process.env.REACT_APP_API_ENDPOINT}uploads/homam/${hotel.thumb_new.replace(/ /g, '%20')}`}
                                  alt="image"
                                  />
            
                                </div>
            
                              </div>
            
                            </div>
            
                            <div className="hotelsCard__content mt-10 text-center">
                              <h4 className="hotelsCard__title text-dark-1 text-18 lh-16 fw-500">
                                <span>{hotel.name}</span>
                              </h4>
            
                              <div className="mt-5">
                                <div className="fw-500">
                                  {!hotel.charges_1 || hotel.charges_1 === 0
                                    ? "Starts from"
                                    : ''}
                                  <span className="text-blue-1">
                                  {!hotel.charges_1 || hotel.charges_1 === 0
                                    ? "Contact us for Price"
                                    : `₹${hotel.charges_1}/-`}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </a>
            
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
      
              </div>
            </div>
            
          </section>
        );
      } else if (widget.widget_category === 'astrology' && widget.homamData) {
        return (
          <section key={widget.id} className="layout-pt-md layout-pb-md">
            <div data-anim="slide-up delay-1" className="container is-in-view">
              <div className="row y-gap-10 justify-between items-end">
                <div className="col-auto">
                  <div className="sectionTitle -md">
                    <h2 className="sectionTitle__title">{widget.widget_name}</h2>
                  </div>
                </div>
      
                <div className="col-auto md:d-none">
      
                  <a href="/homam-astrology/page/1" className="button -md -blue-1 bg-blue-1-05 text-blue-1">
                    View All Astrology <div className="icon-arrow-top-right ml-15"></div>
                  </a>
      
                </div>
              </div>
      
              <div className="relative overflow-hidden pt-40 sm:pt-20 js-section-slider swiper-initialized swiper-horizontal swiper-backface-hidden swiper-pointer-events swiper-autoheight swiper-watch-progress is-in-view" data-gap="30" data-scrollbar data-slider-cols="xl-4 lg-3 md-2 sm-2 base-1" data-nav-prev="js-hotels-prev" data-pagination="js-hotels-pag" data-nav-next="js-hotels-next">
                <div className="swiper-wrapper">
                  <Swiper
                    spaceBetween={30}
                    autoplay={{
                      delay: 2500,
                      disableOnInteraction: false,
                    }}
                    loop={true}
                    navigation={true}
                    modules={[Autoplay, Navigation]}
                    className="mySwiper"
                    breakpoints={{
                      // When window width is <= 767px (typically mobile phones), show 2 slides
                      767: {
                        slidesPerView: 2,
                      },
                      // Default: When window width is > 767px, show 4 slides
                      // You can adjust this breakpoint based on your design requirements
                      768: {
                        slidesPerView: 4,
                      },
                    }}
                  >
                    {widget.homamData.map((hotel) => (
                      <SwiperSlide>
                        <div className="swiper-slide swiper-slide-visible swiper-slide-active" style={{marginRight:"30px"}} key={hotel.id}>
            
                          <a href={`/homam-astrology/${hotel.id}/${hotel.name.toLowerCase().replace(/\s+/g, '-')}`} className="hotelsCard -type-1 ">
                            <div className="hotelsCard__image">
            
                              <div className="cardImage ratio ratio-1:1">
                                <div className="cardImage__content">
                                  <img
                                  src={`${process.env.REACT_APP_API_ENDPOINT}uploads/homam/${hotel.thumb_new.replace(/ /g, '%20')}`}
                                  alt="image"
                                  />
            
                                </div>
            
                              </div>
            
                            </div>
            
                            <div className="hotelsCard__content mt-10 text-center">
                              <h4 className="hotelsCard__title text-dark-1 text-18 lh-16 fw-500">
                                <span>{hotel.name}</span>
                              </h4>
            
                              <div className="mt-5">
                                <div className="fw-500">
                                  {!hotel.price || hotel.price === 0
                                    ? "Starts from"
                                    : ''}
                                  <span className="text-blue-1">
                                  {!hotel.price || hotel.price === 0
                                    ? "Contact us for Price"
                                    : `₹${hotel.price}/-`}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </a>
            
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
      
              </div>
            </div>
            
          </section>
        );
      } else if (widget.widget_category === 'ecommerce') {
        return (
          <section key={widget.id} className="layout-pt-lg layout-pb-md">
            <div className="ecommerce_container"></div>
          </section>
        );
      } else {
        return null; // Widget category not recognized
      }
    });
  };


  //Header image slider
  const [swiperData, setSwiperData] = useState([]);
  
  useEffect(() => {
    const microDataUrl = `${process.env.REACT_APP_API_ENDPOINT}image_retrieve?site_category=home_banners&id=1`;
    console.log('microDataUrl:', microDataUrl);
    // Replace with your API URL
    fetch(microDataUrl)
      .then((response) => response.json())
      .then((data) => setSwiperData(data))
      .catch((error) => console.error('Error fetching data:', error));
  }, []);

  return (
    <>
    <Helmet>
      <meta charSet="utf-8" />
      <title>Tour Packages, Holidays, Hotels & Homam in India | Blessingsonthenet.com</title>
    </Helmet>
    <section data-anim-wrap className="masthead -type-1 z-5">
      <div data-anim-child="fade" className="swiper-wrapper masthead__bg">
        <Swiper
          spaceBetween={30}
          autoplay={{
            delay: 8000,
            disableOnInteraction: false,
          }}
          slidesPerView={1}
          loop={true}
          modules={[Autoplay]}
          className="mySwiper"
        >
          {swiperData.map((item) => (
            <SwiperSlide key={item.id}>
              <img src={`${process.env.REACT_APP_API_ENDPOINT}uploads/home_banners/${item.image_path}`} alt={`Slide ${item.id}`} className="js-lazy" />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      
      <div className="container">
        <div className="row justify-center">
          <div className="col-auto">
            <div className="text-center mb-40">
              <h1 data-anim-child="slide-up delay-1" className="text-30 lg:text-40 md:text-30 text-white">The Most Trusted Travel And Spiritual Website In India</h1>
              <p data-anim-child="slide-up delay-2" className="text-white mt-6 md:mt-10 text-22">Crafting Your Unforgettable Travel Experiences</p>
            </div>

            <PrimarySearchBox />
          </div>
        </div>
      </div>
      
    </section>
    <section className="z-5 mb-50 mobile_hidden" style={{position:'relative', marginTop:'-80px'}}>
      <div style={{height:'60px'}} className="swiper-wrapper masthead__bg">
        <Swiper
          spaceBetween={30}
          autoplay={{
            delay: 8000,
            disableOnInteraction: false,
          }}
          slidesPerView={1}
          loop={true}
          modules={[Autoplay]}
          className="mySwiper"
        >
          {swiperData.map((item) => (
            <SwiperSlide key={item.id}>
              <img style={{display:'none'}} src={`${process.env.REACT_APP_API_ENDPOINT}uploads/home_banners/${item.image_path}`} alt={`Slide ${item.id}`} className="js-lazy" />
              {item.caption != null ?
              (<center>
                <a target="_blank" href={item.caption}>
                  <button class="view_offer_btn float-right mainSearch__submit button -dark-1 h-60 px-35 col-12 rounded-100 bg-blue-1 text-white">View this Offer &nbsp;<span className='icon-play'></span></button>
                </a>
              </center>) : null
              }
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      
    </section>

    {widgetData.length > 0 ? renderWidgetSections() : <p className='text-center'>Loading data, please wait...</p>}


    <section class="section-bg layout-pt-lg layout-pb-lg">
      <div class="section-bg__item -mx-20 bg-light-2"></div>

      <div data-anim-wrap class="container">
        <div data-anim-child="slide-up delay-1" class="row justify-center text-center">
          <div class="col-auto pt-40">
            <div class="sectionTitle -md">
              <h2 class="sectionTitle__title">Customer Testimonials</h2>
              <p class=" sectionTitle__text mt-5 sm:mt-0">When our guests experienced their dream come true</p>
            </div>
          </div>
        </div>

        <div class="relative mt-40 md:mt-40 js-section-slider" data-gap="30" data-slider-cols="xl-3 lg-3 md-2 sm-1 base-1">
          <div class="swiper-wrapper">

            <div data-anim-child="slide-up delay-2" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">21 Day India Tour – Sole Female Tourist from UK Travelling across
Maharashtra – Rajasthan – Himachal Pradesh</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;Hi Ramesh,
                  I personally want to thank you for all your hard work & support you gave me during my yatra.
                  All your team were great too, everyone looked after me.
                  If you or your team need anything from UK, just drop me a line, I will be happy to help.
                  My trip has encouraged me to travel more with your company as I have received a lot of personnel attention & care.
                  I can’t thank you enough
                  &quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Vidi</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-3" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Second Tour of Vidi - Jammu & Kashmir, Amarnath, Vaishno Devi</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;Dear Ramesh,
Once again Many Thanks for organizing my 2nd Yatra, which was a success by the grace of god.
Again I can’t thank you enough for looking after me & organizing my trip, you have wonderful contacts/agents which were so helpful,
informative & looked after me as well.
Kashmir is definitely heaven on earth, very beautiful, Amarnath was breath taking, Katra again was so peaceful & Shiv Khori was a
wonderful spiritual experience I had.
Deepa & Dinesh were very helpful too, Thank you. Look forward to plan more yatra with wonderful company & people in future.
God bless you with all the happiness & prosperity.
Best Wishes
Vidi&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Vidi</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-3" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Senior Citizens on their Pilgrimage Tour - Pune Pandharpur Tuljapur
Nashik</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;Hi Mr.Sekar,
My mom and her friends returned to chennai on Saturday night.
All three were quite happy about their tour. They felt the trip was so nice and comfortable from the beginning to end.
I would like to thank you for the wonderful arrangements and prompt responses through email.
Thank you once again.&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Shree</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-4" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Guest from Dubai –Tour of Ashtavinayak Pandharpur Mahalaxmi Temple
Kolhapur</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;Dear rajeshree
We had a good tour of AshtaVinayak and Pandarpur and all the rest of the itinery as planned Had a wonderful trip and great darshans.
Feeling happy and blessed.
We have been dropped off at Pune airport, to catch our flight to a Dubai.
Thanks for all your efforts and planning.
Looking forward to doing yet another tour with BLESSINGS ON THE NET
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">JANAKI GOPALA</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-5" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Guest from Coimbatore on Shirdi Tour</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;Hello Pallavi,
I would like to thank you for all the help you have done to make our travel " The best experience" for us! The driver you have
arranged Mr. Suresh was knowledgeable and very helpful even though we had some language issues, we are extremely happy with the
service and totally recommend your agency to our friends and family. &quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Courtney Henry</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Web Designer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Guest from London – WomenTraveller Tour of Mumbai - Shirdi</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;Thank You For Your Assistance , It was the Best Experience ever , Still Need to Book Extra Luggage for flight to Delhi, Did Some Shopping in Shirdi&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Guest from London</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Guest from Coimbatore on Shirdi Tour</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;I would like to convey our sincere thanks for Nirvana India Enterprise,Yourself,Dinesh sharma,and our cab driver Ganesh for all the
arrangements for our Pune-Bheema sankar-Pandarpur-solapur-tuljapur-pune tour for 3 day from 28th Feb to 2nd Marc2016.The stay ,
itinerary, vehicle and the friendliness of all of you was very nice and entire tour was trouble free by God's grace and the involvement
of all.of you. My thanks.
Kindly convey this to all concerned who are part of this tour. I look forward for many such tours with you.
When you are free please suggest such 2nights/3days tour of certain places If there is any feed back form pl send i will fill up.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">L.SUNDARARAMAN</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Business Partner ( Travel Agent) on a tour organized by Nirvana</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;Dear Ramesh,
Greetings from Goodness!
My apology to send my feedback bit late as was traveling.
The client whom you handled through us rated your service as ‘Very Good'. Am too happy that we have chosen a right partner
for this service and look forward for a rewarding relationship.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Lawrence M Rosario</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Business Partner</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Business Partner ( Travel Agent) on a tour organized by Nirvana</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;1Night/2 Days Dear All, First of all please accept my sincere thanks to everyone those who ever dedicated in this particular
booking. The client had confirmed that the trip was excellent. Review : Mr,Yasunathan who had taken care the guest very
well right from the Pune airport pick up till the drop point end to end which is really amazing. Over and above you have
upgraded the car category as Innova through out the trip simply superb! Also booked hotel and the Deluxe category room was
really excellent. I am so glad really i found the best professionals in the market.... Thank you all......... With immediate effect
I will make sure that whatever packages within India will reach you by default from the undersigned. Once again my sincere
thanks to all and take care!
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">K.SHANKAR</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">NATURE TOURS AND AIR TRAVEL SERVICES</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            
            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">All India Pilgrimage - 15 Day Tour Done by a client from USA</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;Ramesh is the only travel agent in India that I would use for all my personal tours when I visit India. I have had him handle all my excursions for the past nine years and they have all been extremely well organized within my budget and within my specifications on privacy and safety. With so many options available for cheap travel on the Internet one can never be assured of safety nor can one be able to find alternatives when something goes wrong. Ramesh and his team were able to help us when some of our flight-bookings in India were cancelled at the last minute and we had to be at our next destination on time to continue on with the the rest of the tours we booked. Ramesh got us a car and got us there. Every car & driver that Ramesh & his team provided was very safe for my travels alone and with my sister as just two elderly ladies going alone.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Nalini Uhrig</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Shirdi Tour of a Family from Bangalore</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;Om Sai. We are delighted customers after having wonderful darshan of Shirdi Saibaba. We had an excellent tour package done by your team. I think the entire booking was done in less than half hour or even lesser with meeting my expectations to the point, no false promises, no high prices, and entirely a pleasant experience from start to end. Mr. Ramesh, I am extremely happy to say that you were prompt, responsive and a one stop solution during my entire booking till execution of the trip. We as your customers were very delighted. And a special thanks to you for going an extra mile to accommodate us at Sun n San beyond the regular check out time. It helped us a lot. Mr. Dinesh. Thanks for providing guidance and assistance whenever needed through calls, SMS and whatsapp. Every single gesture is worth thanking for your wonderful work. Driver was exceptionally good. Mr Sunil. His driving capability that included road alertness and traffic manoeuvring was very commendable. He drove to our destination on time. Sun n Sand was a perfect choice.... We enjoyed the hospitality, breakfast, lunch and every moment of our stay was memorable. Over all the entire trip to shirdi was pleasant and beyond our expectations. Our picture at Sun n Sand Shirdi having continental breakfast.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Suparna Shankar</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Traveler from USA –Tour to Shirdi, Ashtavinayak & Pancha Jyotirlinga</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;Dear Ramesh, Great Service! You proved me wrong. All my doubts were baseless. Suresh very courteous. He represented the culture of your organization. Keep up the good work.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Anil Mehta</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Senior Citizens on their Pilgrimage Tour -Pune Pandharpur Tuljapur Nashik</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;My mom and her friends returned to chennai on Saturday night. All three were quite happy about their tour. They felt the trip was so nice and comfortable from the beginning to end. I would like to thank you for the wonderful arrangements and prompt responses through email. Thank you once again.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Shree</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Senior Citizen Couple on their Pilgrimage Tour of Maharashtra</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;Dear Mr. Ramesh, Thanks to you and entire your company members for arranging excellent and memorable pilgrimage tour. We had comfortable tour and driver Ashok was excellent. He was very calm and safe driver. He took to all places to accuracy and helped in guiding at times. All hotels were O.K. Especially Shirdi ( Veer sai) They were very good in courtesy. All darshans were easy and satisfied. Veer Sayi is just 5 minutes to temple. We had darshan many times due to it. You can advise your customers to book darshan on line or go to PRO office near to our hotel and we can get pass within 2 minutes. For senior cirizens(more than 65 years) it is free except on Saturday and Sunday. No time was wasted on problems on car which generally happen for such long tour. Myself and my wife Lakshmi congratulate you and entire team for providing such excellent package. Shirdi Sayi baba,Ashta Vinayaks, Pandarpur Vitoba, Tuljapur Bhavani,Triambakeshwar,Shaniji will shower blessings to you all. We are moving to Kolhapur mahalakshmi temple. I must not have covered all places seen in this tour. Tomorrow night we will return back to Chennai but it was a life time ambitious made real. We couldn't able to see Ellora since it wasTuesday and was Holiday. Pl. note to take care for future tours of others. Once again, we are very happy with your driver Ashok. He was excellent.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Mohan and Lakshmi</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Guest from Dubai –Tour of Ashtavinayak Pandharpur Mahalaxmi Temple Kolhapur</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;Dear rajeshree We had a good tour of AshtaVinayak and Pandarpur and all the rest of the itinery as planned Had a wonderful trip and great darshans. Feeling happy and blessed. We have been dropped off at Pune airport, to catch our flight to a Dubai. Thanks for all your efforts and planning. Looking forward to doing yet another tour with BLESSINGS ON THE NET
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">GOPALAN JANAKI GOPALA</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Facebook Post of a Guest –Tour Package Best Of Kashmir 10 Nights 11 Day</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;A picturesque lake a little away from srinagar. We also did a round in the shopping area in Srinagar. Unfortunately shops were closed because of a local election happening here. (But I did shopping already .Leaving tomorrow from this beautiful city.. with loads and loads of memories. Many have pinged me already to know about the trip. It's a must visit place for all Indians before we go on any foreign trips. I have never felt the warmth of people in any other state. Such loving people everywhere who will take care of you like their own. They deserve the best. Their livelihood depends on tourism. Without having any fear or any second thoughts just go for it. It's a heaven on earth. Thanks to BlessingsOnthenet for organising this wonderful trip. It was such a flawless experience. Tomorrow will be tough to bid bye to this beautiful place I have ever seen. Will definitely come back in a summer to see the blooming beauty.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Sharda</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Guest from Coimbatore on Shirdi Tour</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;Hello Pallavi, I would like to thank you for all the help you have done to make our travel "The best experience" for us! The driver you have arranged Mr. Suresh was knowledgeable and very helpful even though we had some language issues, we are extremely happy with the service and totally recommend your agency to our friends and family.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Sathya Elango</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Pune-Bheema sankar-Pandarpur-solapur-tuljapur-pune tour for 3 days</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;Dear Ramesh krishnan, I would like to convey our sincere thanks for Nirvana India Enterprise, Yourself, Dinesh sharma, and our cab driver Ganesh for all the arrangements for our Pune-Bheema sankar-Pandarpur-solapur-tuljapur-pune tour for 3 day from 28th Feb to 2nd Marc2016.The stay, itinerary, vehicle and the friendliness of all of you was very nice and entire tour was trouble free by God's grace and the involvement of all.of you. My thanks. Kindly convey this to all concerned who are part of this tour. I look forward for many such tours with you. When you are free please suggest such 2nights/3days tour of certain places.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">L.SUNDARARAMAN</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Kathmandu Pokhara & Muktinath Pilgrimage Tour</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;We had a very good and memorable experience in our Muktinath travel.. hats off to the planning team that every requirement was taken care flawless.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Mamtha</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Best Of Maharashtra Temple Hill Station & Heritage Tour 11 1Night 12 Days</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;We went on hill station and pilgrimage package tour from 28th April 2024 to 9th April 2024. It was good experience, hotels were up to the mark and vehicle was in good condition well planed itinerary.. overall good experience. Happy about our trip.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Vjaylakshmi</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Kolhapur Pandharpur Tuljapur Akkalkot 2 Night 3 Days from Kolhapur</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;Very comfortable till end of our tour.well organization. Hotels provided for stay was too good. food Quality is also good. Vehicle and driver is so perfect. I highly recommend to everyone Nirvana India Enterprises is the best solution.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Ms. Madhura</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Kerala Temple Tour With Sabarimala Package 04 Nights and 05 Days Ex Cochin</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;We did a five day trip of Sabarimala n Guruvayur and other temples through Nirvana. Ramesh was involved in planning the itinery from the start and the arrangements were very good. The car, driver, hotel choices, planned ng of temple visits given expected crowds and closing timings were all very good. He and his team were always available on call and in fact I had the good fortune of Ramesh himself travelling there at the same time and exchanging tips. Very very welk organized trip. Will do more trips through them.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Harihar Krishnamoorthy</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Sapta Kshetra Darshan 3 Night 4 Days Mangalore to Mangalore</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;Dear Ramesh Krishnan, My thanks for the excellent arrangements you have made for the tour to the pilgrim places. (subramanya, dharmastala, kollur, udupi, mangalore,Kukke) The driver you have provided was well versed of all the places and he has taken us to all the places in a short time with courteous behaviour. The rest places arranged were also in fine condition. In a short time we have seen most of the pilgrim places with comfort and ease.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">S.Rakeswar</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Safe & Memorable Shirdi Trip</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;The trip to Shirdi was very good. We were only 4 ladies and we had a very safe, comfortable and memorable journey. All the arrangements were done we just to co-ordinate with the concern people. 1) Ticket booking was done without any follow ups 2) The hotel accommodation and the food was very good and up to expectations 3) Facility of pick up and drop was also there and the vehicle was in good condition, so we need not worried about the local conveyance in Shirdi 4) The service was overall good, we enjoyed the trip I would suggest every body to use this service and found worth it.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Bidushi</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Shirdi visit</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;I had a successful trip to Shirdi, thanks to the excellent arrangements done by Nirvana India Enterprise from Pune to Shirdi and back. The driver was very nice and the car a new one. The Hotel KBs Grand was very good, and the staff were very hospitable. My appreciation for the good work done by Nirvana.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">M Venkataramani Doha</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Outstanding Tour</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;We went on 5 day trip to Maharashtra Jyotirlingas and Shirdi from 29th December through Jan 2nd. First of all Ms. Swati assisted really well in putting up an itinerary. She was able to clearly understand the requirements and come up with a schedule. Initially we were promised only a Indigo, at the last minute they upgraded us to Innova for no additional charge. Which company does that !! Mr Anup was the driver cum guide. He was promptly present at Pune Airport. He showed us all the places as per the itinerary and even showed us extra places like Ranjangaon , Alandi , Godavari birth place. He knows the routes like the back of his hand and was extremely friendly. Also, all the hotels provided for stay were top class and had good amenities. I would recommend blessingsonthenet to all my friends and relatives. Even, I am looking forward for my next trip - AshtaVinayak tour sometimes next year.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Venkat</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Sapta Kshetra Darshan From Mangalore</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;No doubt,It was a memorable and well organised trip. The Hotel at Mangalore was very average and can be avoided. Once again, many a thanks for the service.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">V.SUBRAMANIAN</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div data-anim-child="slide-up delay-6" class="swiper-slide">
              <div class="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40">
                <h4 class="text-16 fw-500 text-blue-1 mb-30">Pune Shirdi Jyotirlinga tour Package</h4>
                <p class="testimonials__text lh-18 fw-500 text-dark-1">&quot;We are very happy with the travel arrangements . The stay at pune hotel and hotel veersai shirdi was very nice and clean and beyond expectation. the driver Suresh was very accommodative and well mannered . he was more of a guide than a driver. our wishes to him.
&quot;</p>

                <div class="pt-20 mt-28 border-top-light">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto">
                      <img class="size-60" src="img/avatar.png" alt="image" />
                    </div>

                    <div class="col-auto">
                      <div class="text-15 fw-500 lh-14">Prashanth</div>
                      <div class="text-14 lh-14 text-light-1 mt-5">Customer</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>


          <button class="section-slider-nav -prev flex-center button -blue-1 bg-white shadow-1 size-40 rounded-full sm:d-none js-prev">
            <i class="icon icon-chevron-left text-12"></i>
          </button>

          <button class="section-slider-nav -next flex-center button -blue-1 bg-white shadow-1 size-40 rounded-full sm:d-none js-next">
            <i class="icon icon-chevron-right text-12"></i>
          </button>

        </div>
      </div>
    </section>
    
    {/*
    <section className="layout-pt-md layout-pb-md">
      <div className="container">
        <div className="row y-gap-20">
          <div data-anim="slide-up" className="col-md-6">

            <div className="ctaCard -type-1 rounded-4 ">
              <div className="ctaCard__image ratio ratio-63:55">
                <img className="img-ratio js-lazy" src="#" data-src="/assets/img/backgrounds/1.png" alt="image" />
              </div>

              <div className="ctaCard__content py-70 px-70 lg:py-30 lg:px-30">


                <h4 className="text-40 lg:text-26 text-white">Hotel Sun & Sand<br /> Shirdi</h4>

                <div className="d-inline-block mt-30">
                  <a href="#" className="button px-48 py-15 -blue-1 -min-180 bg-white text-dark-1">View Details</a>
                </div>
              </div>
            </div>

          </div>

          <div data-anim="slide-up delay-1" className="col-md-6">

            <div className="ctaCard -type-1 rounded-4 ">
              <div className="ctaCard__image ratio ratio-63:55">
                <img className="img-ratio js-lazy" src="#" data-src="/assets/img/holidays/2.png" alt="image" />
              </div>

              <div className="ctaCard__content py-70 px-70 lg:py-30 lg:px-30">

                <div className="text-15 fw-500 text-white mb-10">Enjoy Summer Deals</div>


                <h4 className="text-40 lg:text-26 text-white">Up to 70% Discount!</h4>

                <div className="d-inline-block mt-30">
                  <a href="#" className="button px-48 py-15 -blue-1 -min-180 bg-white text-dark-1">Learn More</a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>


    <section style={{paddingTop:120}} className="layout-pt-lg layout-pb-lg bg-blue-2">
      <div data-anim-wrap className="container">
        <div className="row y-gap-40 justify-between">
          <div data-anim-child="slide-up delay-1" className="col-xl-5 col-lg-6">
            <h2 className="text-30">What our customers are<br /> saying about us?</h2>
            <p className="mt-20">We have been serving holiday packages on various categories for over 15 years now with most of the client with happy faces.</p>

            <div className="row y-gap-30 pt-60 lg:pt-40">
              <div className="col-sm-5 col-6">
                <div className="text-30 lh-15 fw-600">5k+</div>
                <div className="text-light-1 lh-15">Happy Customers</div>
              </div>

              <div className="col-sm-5 col-6">
                <div className="text-30 lh-15 fw-600">4.88</div>
                <div className="text-light-1 lh-15">Overall rating</div>

                <div className="d-flex x-gap-5 items-center pt-10">

                  <div className="icon-star text-blue-1 text-10"></div>

                  <div className="icon-star text-blue-1 text-10"></div>

                  <div className="icon-star text-blue-1 text-10"></div>

                  <div className="icon-star text-blue-1 text-10"></div>

                  <div className="icon-star text-blue-1 text-10"></div>

                </div>
              </div>
            </div>
          </div>

          <div data-anim-child="slide-up delay-1" className="col-lg-6">
            <div className="overflow-hidden js-testimonials-slider-3" data-scrollbar>
              <div className="swiper-wrapper">

                <div className="swiper-slide">
                  <div className="row items-center x-gap-30 y-gap-20">
                    <div className="col-auto">
                      <img src="#" data-src="/assets/img/avatar.png" alt="image" className="js-lazy" />
                    </div>

                    <div className="col-auto">
                      <h5 className="text-16 fw-500">Anitha Rajan</h5>
                      <div className="text-15 text-light-1 lh-15">Working Profession</div>
                    </div>
                  </div>

                  <p className="text-18 fw-500 text-dark-1 mt-30 sm:mt-20">Blessingsonthenet team helped us getting best holiday package and we are very happy with their service. I would highly recommend to my friends. Give it a try and experience their service once.</p>
                </div>

                <div className="swiper-slide">
                  <div className="row items-center x-gap-30 y-gap-20">
                    <div className="col-auto">
                      <img src="#" data-src="/assets/img/avatar.png" alt="image" className="js-lazy" />
                    </div>

                    <div className="col-auto">
                      <h5 className="text-16 fw-500">Annette Black</h5>
                      <div className="text-15 text-light-1 lh-15">UX / UI Designer</div>
                    </div>
                  </div>

                  <p className="text-18 fw-500 text-dark-1 mt-30 sm:mt-20">The place is in a great location in Gumbet. The area is safe and beautiful. The apartment was comfortable and the host was kind and responsive to our requests.</p>
                </div>

                <div className="swiper-slide">
                  <div className="row items-center x-gap-30 y-gap-20">
                    <div className="col-auto">
                      <img src="#" data-src="/assets/img/avatar.png" alt="image" className="js-lazy" />
                    </div>

                    <div className="col-auto">
                      <h5 className="text-16 fw-500">Annette Black</h5>
                      <div className="text-15 text-light-1 lh-15">UX / UI Designer</div>
                    </div>
                  </div>

                  <p className="text-18 fw-500 text-dark-1 mt-30 sm:mt-20">The place is in a great location in Gumbet. The area is safe and beautiful. The apartment was comfortable and the host was kind and responsive to our requests.</p>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
    */}
    <SubscribeRibbon />

    </>
  );
}

export default Home;